import { render, staticRenderFns } from "./PayoutCardErrorAlert.vue?vue&type=template&id=0496d116&"
import script from "./PayoutCardErrorAlert.vue?vue&type=script&lang=js&"
export * from "./PayoutCardErrorAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports